import React from 'react'
import CacheSettings from './CacheSettings'
import AlertContainer from 'react-alert'
import { flush } from '../../api/cache'

class CacheSettingsContainer extends React.PureComponent {
  constructor (props, context) {
    super(props, context)
    this.state = {}
  }

  componentDidMount () {
  }

  onFlush = async () => {
    let message = `Successfully cleared cache`
    try {
      await flush()
      this.msg.show(message, { type: 'success', time: 6000 })
    } catch (error) {
      message = error.data ? error.data.message : 'An error clearing cache'
      this.msg.show(message, { type: 'error', time: 6000 })
    }
  }

  render () {
    const methods = {
      onFlush: this.onFlush
    }
    const dangerAlertOptions = {
      offset: 14,
      position: 'top right',
      theme: 'dark',
      time: 5000,
      transition: 'scale'
    }
    return <div>
      <CacheSettings {...this.props} {...this.state} {...methods} />
      <AlertContainer ref={a => (this.msg = a)} {...dangerAlertOptions} />
    </div>
  }
}

CacheSettingsContainer.propTypes = {}

export default CacheSettingsContainer



// WEBPACK FOOTER //
// ./src/components/CacheSettings/CacheSettingsContainer.js